import { useCompanyMembers, useRoleContext } from "hooks";

import { ShareShipmentMenu } from "./ShareShipmentMenu";

interface Props {
  setShareeRoleIds: (roleIds: number[]) => void;
  selectedSharees: number[];
  onClose: VoidFunction;
  isProject: boolean;
  autoFocus?: boolean;
}

export function ShareShipmentMenuContainer(props: Props) {
  const {
    setShareeRoleIds,
    selectedSharees,
    onClose,
    isProject,
    autoFocus = false,
  } = props;
  const { role } = useRoleContext();
  const {
    members,
    error: CompanyMemberFetchError,
    loading: CompanyMemberFetchLoading,
  } = useCompanyMembers();

  if (!role) {
    return null;
  }

  const companyMembersWithoutSelf = members.filter(
    (member) => member.id !== role.id,
  );

  return (
    <ShareShipmentMenu
      loading={CompanyMemberFetchLoading}
      loadCompanyMembersError={CompanyMemberFetchError}
      companyMembers={companyMembersWithoutSelf}
      setShareeRoleIds={setShareeRoleIds}
      selectedCompanyMembers={selectedSharees}
      onClose={onClose}
      isProject={isProject}
      autoFocus={autoFocus}
    />
  );
}
